import { AxiosResponse } from 'axios';
import { betSettlementList } from '@/api/betSettlement';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IBetSettlementApiListResponse, IListParams } from '@/types';

export const betSettlementService = {
    async list(params: IListParams): Promise<AxiosResponse<IBetSettlementApiListResponse>> {
        try {
            return await baseListService<IBetSettlementApiListResponse>(betSettlementList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Bet Settlement API Error:', e);
            throw new AppError('Unable to load bet settlement list, request error', { cause: e });
        }
    },
};
